import React from 'react';
import { Button } from 'primereact/button';
import { DataTable } from './DataTable';
import { TableProps, TableHeaderProps } from '../types/table.types';

export interface TableWithHeaderProps<T = any> extends TableProps<T> {
  header?: TableHeaderProps<T>;
}

export function TableWithHeader<T extends Record<string, any>>({
  header,
  ...tableProps
}: TableWithHeaderProps<T>) {
  return (
    <div className="space-y-6">
      {/* Header */}
      {header && (
        <div className="flex items-center justify-between">
          <div>
            {header.title && (
              <h1 className="text-2xl font-bold text-gray-900">{header.title}</h1>
            )}
            {header.subtitle && (
              <p className="text-gray-600">{header.subtitle}</p>
            )}
          </div>
          {(header.secondaryButton || header.actionButton) && (
            <div className="flex items-center gap-2">
              {header.secondaryButton && (
                <Button
                  icon={header.secondaryButton.icon}
                  label={header.secondaryButton.label}
                  className={`p-button-outlined ${header.secondaryButton.className || ''}`}
                  onClick={header.secondaryButton.onClick}
                />
              )}
              {header.actionButton && (
                <Button
                  icon={header.actionButton.icon}
                  label={header.actionButton.label}
                  className={`p-button-primary ${header.actionButton.className || ''}`}
                  onClick={header.actionButton.onClick}
                />
              )}
            </div>
          )}
        </div>
      )}

      {/* Table */}
      <DataTable {...tableProps} />
    </div>
  );
} 